import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Input, Button, Modal, Spin, ConfigProvider } from 'antd';
import { UserOutlined, LockOutlined, UnlockOutlined, MailOutlined } from '@ant-design/icons';
import api from '../../services/api'
import styles from '../../services/styles'
import { displayMessage } from '../../helpers/messages'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import SL_Button from '../../components/buttons/Button';
import { SL_Input } from '../../components/input/Input';

const { tc1, tc2, bc1, bc2, bc4, bc7, COLORS } = styles

export const LoginForm = () => {

    const {
        setLoggedUser,
        mobile_mode
    } = useContext(GeneralContext)

    const [errorLogin, setErrorLogin] = useState(null);

    const [isModalRecuperarSenhaVisible, setIsModalRecuperarSenhaVisible] = useState(false)
    const [isModal2FAVisible, setIsModal2FAVisible] = useState(false)

    const [email, setEmail] = useState(null)
    const [token2FA, setToken2FA] = useState(null)
    const [showLoading, setShowLoading] = useState(false)

    const navigate = useNavigate()

    const onFinish = async (values) => {
        try {
            const rs = await api.auth.authenticate(values)
            const { user, token } = rs?.data

            const formattedToken = 'Bearer ' + token

            api.auth.setAuthorizationToken(formattedToken)

            setLoggedUser(user)

            if (user?.must_change_password) {
                navigate('/change-password')
            }
        } catch (e) {
            alert(displayMessage('LOGIN_ERROR'), 'error', displayMessage('ERROR'))
            setErrorLogin(e?.response?.data?.error ? e?.response?.data?.error : displayMessage('INVALID_LOGIN'))
        }
    }

    const handleOkPasswordRecovery = () => {
        if (!email) {
            alert(displayMessage('INVALID_EMAIL'))
            return
        }

        setShowLoading(true)

        api.auth.forgotPassword(email)
            .then(
                rs => {
                    setTimeout(() => {
                        handleCloseModalRecuperarSenha()

                        setShowLoading(false)

                        if (rs.status == 200) {
                            alert((displayMessage('FORGOT_PASSWORD_SUCCESS')), 'success', displayMessage('SUCCESS'), 8)
                        }
                    }, 500)
                }
            ).catch(() => {
                setTimeout(() => {
                    setShowLoading(false)
                }, 500)
            })
    }

    const handleOnValidate2FAToken = async () => {

        // try {
        //     const rs = await api.auth.twoFactorLogin({ email, token_2FA: token2FA })

        //     const { token, user } = rs?.data
        //     const formattedToken = 'Bearer ' + token

        //     api.auth.setAuthorizationToken(formattedToken)
        //     localStorage.setItem('user', JSON.stringify(user))

        //     setLoggedUser(true)

        // } catch (err) {
        //     console.error('Token invalido', err)
        // }
    }

    const handleCloseModalRecuperarSenha = () => {
        if (showLoading) {
            return
        }

        setIsModalRecuperarSenhaVisible(false)
        setEmail(null)
    }

    const handleCloseModal2FA = () => {
        setIsModal2FAVisible(false)
    }

    const renderModalRecuperarSenha = () => {
        return (
            <>
                <Modal
                    title={<div style={{ color: COLORS.RED[900] }}>{displayMessage('RECOVER_PASSWORD')}</div>}
                    open={isModalRecuperarSenhaVisible}
                    onCancel={handleCloseModalRecuperarSenha}
                    onOk={handleOkPasswordRecovery}
                    centered={true}
                    footer={
                        !showLoading && (
                            <div className='flex flex-col ss:flex-row gap-2 justify-end'>
                                <SL_Button variant={'close'} className="w-full ss:w-[150px] font-bold" onClick={handleCloseModalRecuperarSenha}>{displayMessage('CLOSE')}</SL_Button>

                                <SL_Button className="w-full m-0 ss:w-[150px] font-bold" onClick={handleOkPasswordRecovery}>{displayMessage('CONFIRM')}</SL_Button>
                            </div>
                        )
                    }
                >
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', minHeight: showLoading ? 114 : 70 }}>
                        {
                            showLoading ?
                                <div>
                                    <Spin tip="Aguarde..." />
                                </div>
                                :
                                <div style={{ display: 'flex', flexDirection: 'column', fontSize: 13, flex: 1, color: COLORS.RED[900] }}>
                                    <div style={{ fontWeight: 'bold', marginBottom: 5 }}>{displayMessage('DISPLAY_REGISTERED_EMAIL')}:</div>

                                    <SL_Input
                                        type={"email"}
                                        value={email}
                                        required={true}
                                        onChange={
                                            e => {
                                                setEmail(e.target.value)
                                            }
                                        }
                                    />
                                </div>
                        }
                    </div>
                </Modal>
            </>
        )
    }

    const renderModal2FA = () => {
        return (
            <>
                <Modal
                    title={displayMessage('TWO_FACTOR_AUTH_MODAL_TITLE')}
                    open={isModal2FAVisible}
                    onCancel={handleCloseModal2FA}
                    centered={true}
                    footer={null}
                >
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%' }}>
                        {showLoading ?
                            <Spin tip="Aguarde..." />
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 10, alignItems: 'center', maxWidth: 350 }}>
                                <div style={{ fontWeight: 'bold', marginRight: 10, alignSelf: 'center', textAlign: 'center' }}>{displayMessage('TWO_FACTOR_AUTH_SENT_MESSAGE')}</div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <MailOutlined style={{ fontSize: 55 }} />
                                    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                                        <span style={{ fontSize: 14 }}>{displayMessage('DISPLAY_2FA_CODE')} </span>
                                        <Input
                                            type="text"
                                            style={{ width: '100%', height: 30 }}
                                            value={token2FA}
                                            required={true}
                                            onChange={
                                                e => {
                                                    setToken2FA(e.target.value)
                                                }
                                            }
                                        />
                                    </div>
                                </div>
                                <Button onClick={handleOnValidate2FAToken} style={{ width: '100%' }} type="primary"> {displayMessage('VERIFY')} </Button>
                            </div>
                        }
                    </div>
                </Modal>
            </>
        )

    }

    return (
        <>
            {isModalRecuperarSenhaVisible && renderModalRecuperarSenha()}

            {isModal2FAVisible && renderModal2FA()}

            <>
                <div
                    style={{
                        color: tc1,
                        fontWeight: 'bold',
                        marginBottom: 15,
                        fontSize: mobile_mode ? 20 : 24,
                        textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                        color: bc2,
                    }}
                >
                    {displayMessage('LOGIN_TITLE')}
                </div>

                <Form
                    name="normal_login"
                    onFinish={onFinish}
                    style={{ maxWidth: 400, width: '100%' }}
                    layout='vertical'
                    requiredMark={false}
                >
                    <ConfigProvider
                        theme={{
                            token: {
                                colorError: COLORS.RED[650]
                            },
                        }}
                    >
                        <div style={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
                            <div
                                style={{
                                    color: COLORS.GRAY[50],
                                    textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                                    fontWeight: 'bold',
                                    display: 'flex'
                                }}>
                                {displayMessage('EMAIL')}
                            </div>

                            <Form.Item
                                name="email"
                                rules={[{ required: true, message: displayMessage('DISPLAY_EMAIL') }]}
                                style={{ marginBottom: 15 }}
                            >
                                <SL_Input
                                    prefix={<UserOutlined className="site-form-item-icon" />}
                                    placeholder={displayMessage('ENTER_EMAIL')}
                                />
                            </Form.Item>
                        </div>

                        <div style={{ display: 'flex', gap: 2, flexDirection: 'column', marginTop: 5 }}>
                            <div
                                style={{
                                    color: COLORS.GRAY[50],
                                    textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                                    fontWeight: 'bold',
                                    display: 'flex'
                                }}>
                                {displayMessage('PASSWORD')}
                            </div>

                            <Form.Item
                                name="password"
                                rules={[{ required: true, message: displayMessage('DISPLAY_PASSWORD') }]}
                                style={{ marginBottom: 25 }}
                            >
                                <SL_Input
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    type="password"
                                    placeholder={displayMessage('ENTER_PASSWORD')}
                                />
                            </Form.Item>
                        </div>
                    </ConfigProvider>

                    {/* {errorLogin && <span style={{ color: 'red', textAlign: 'center', width: '100%' }}>{errorLogin}</span>} */}

                    <Form.Item hasFeedback style={{ marginBottom: 10, marginTop: 5 }}>
                        <SL_Button
                            type="primary"
                            style={{
                                width: "100%",
                                fontWeight: 'bold',
                                textShadow: '0px 0px 5px #666',
                            }}
                            htmlType="submit"
                        >
                            {displayMessage('ENTER')}
                        </SL_Button>
                    </Form.Item>

                    <Form.Item style={{ margin: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <SL_Button
                                style={{
                                    color: tc2,
                                    fontWeight: 'bold',
                                    textShadow: '#777 1px 2px 1px, 0px 2px 1px rgb(0 0 0 / 0%)',
                                }}
                                type="link"
                                onClick={() => { setIsModalRecuperarSenhaVisible(true); setEmail(null) }}
                            >
                                {displayMessage('RECOVER_PASSWORD')}
                            </SL_Button>
                        </div>
                    </Form.Item>
                </Form>
            </>
        </>
    );
};